import {
  getExchangeNFTAddress,
  getExchangeBakerySoccerAddress,
  getExchangeOneInchBakeNFTAddress,
  getExchangeBakeryArtwork2NFTAddress,
  getExchangeBakeryArtwork3NFTAddress,
  getExchangeSeascapeNFTAddress,
  getExchangeEggNFTAddress,
  getExchangeArtworkNFTAddress,
  getExchangeBinanceNftAddress,
  getExchangeWeaponNFTAddress,
  getExchangeBakeryArtworkNFTAddress,
  getExchangePetNftAddress,
  getExchangeTokocryptoNFTAddress
} from '../sushi/utils'


import { MARKETTYPEV1 } from '../constants/bakery/nft'

export function userExchangeNFTAddress(sushi: any, type?: string) {
  let address = getExchangeNFTAddress(sushi)
  switch (type) {
    case MARKETTYPEV1.DISHV1:
      address = getExchangeNFTAddress(sushi)
      break
    case MARKETTYPEV1.BAKERYSOCCERV1:
      address = getExchangeBakerySoccerAddress(sushi)
      break
    case MARKETTYPEV1.ONEINCHV1:
      address = getExchangeOneInchBakeNFTAddress(sushi)
      break
    case MARKETTYPEV1.MUSKDOGEV1:
      address = getExchangeBakeryArtwork2NFTAddress(sushi)
      break
    case MARKETTYPEV1.MEMEV1:
      address = getExchangeBakeryArtwork3NFTAddress(sushi)
      break
    case MARKETTYPEV1.SEASCAPEV1:
      address = getExchangeSeascapeNFTAddress(sushi)
      break
    case MARKETTYPEV1.EGGNFTV1:
      address = getExchangeEggNFTAddress(sushi)
      break
    case MARKETTYPEV1.BTCARTWORKV1:
      address = getExchangeArtworkNFTAddress(sushi)
      break
    case MARKETTYPEV1.BINANCENFTV1:
      address = getExchangeBinanceNftAddress(sushi)
      break
    case MARKETTYPEV1.WEAPONNFTV1:
      address = getExchangeWeaponNFTAddress(sushi)
      break
    case MARKETTYPEV1.BAKERYARTWORKV1:
      address = getExchangeBakeryArtworkNFTAddress(sushi)
      break
    case MARKETTYPEV1.PETNFTV1:
      address = getExchangePetNftAddress(sushi)
      break
    case MARKETTYPEV1.TKONFTV1:
      address = getExchangeTokocryptoNFTAddress(sushi)
      break
  }
  return address
}
